import { ComponentRoute } from '@/classes'

const BankUndepositedFundRoutes = {
  BankUndepositedFundView: new ComponentRoute('/bankundepositedfund/:CompanyId', 'BankUndepositedFundView'),
  BankUndepositedFundDetail: new ComponentRoute('/bankundepositedfund/:CompanyId', 'BankUndepositedFundDetail')
}

export default BankUndepositedFundRoutes